import React from 'react';
import AdFeesContainer from '../../../Containers/AdminContainer/AdFees';
import AdminLayout from '../../../Components/CommonComponents/Layout/adminLayout';
const AdFeesScreen = () => {
  return <AdFeesContainer />;
};

export default AdFeesScreen;
